export const types = {
  VALIDATE_ADDRESS_MODAL_CHOOSE_ADDRESS:
    'modules/common/modals/validateAddress/VALIDATE_ADDRESS_MODAL_CHOOSE_ADDRESS',
  VALIDATE_ADDRESS_MODAL_CLOSE:
    'modules/common/modals/validateAddress/VALIDATE_ADDRESS_MODAL_CLOSE',
  VALIDATE_ADDRESS_MODAL_OPEN:
    'modules/common/modals/validateAddress/VALIDATE_ADDRESS_MODAL_OPEN',
  VALIDATE_ADDRESS_REQUEST:
    'modules/common/modals/validateAddress/VALIDATE_ADDRESS_REQUEST',
};

export const validateAddress = {
  request: ({
    address1,
    address2,
    callBack,
    city,
    country,
    postalCode,
    state,
  }) => ({
    type: types.VALIDATE_ADDRESS_REQUEST,
    payload: { address1, address2, callBack, city, country, postalCode, state },
  }),
};

export const validateAddressModal = {
  chooseAddress: ({ address }) => ({
    type: types.VALIDATE_ADDRESS_MODAL_CHOOSE_ADDRESS,
    payload: { address },
  }),
  close: () => ({
    type: types.VALIDATE_ADDRESS_MODAL_CLOSE,
  }),
  open: ({ suggestedAddresses }) => ({
    type: types.VALIDATE_ADDRESS_MODAL_OPEN,
    payload: { suggestedAddresses },
  }),
};
